// import { Check, X } from 'lucide-react';
import React from "react";
import styles from "./Comparision.module.scss";
import homeStyles from "../../../styles/Home.module.scss";
const features = [
  "Custom Business Intelligence",
  "B2B AI Co-pilots",
  "Competitor Price Crawlers",
  "B2B Content management",
  "Smart Cataloging Management",
  "Warehouse Management",
  "Inventory Management",
  "Vendor Management",
  "Purchase Order Management",
  "Brand and CPG Management",
  "GeoLocation based Product Pricing",
  "Promotions and offers",
  "E-invoicing",
  "Self Fulfillment and logistics",
  "Integrations with 3PL",
  "Integrations with Payment Gateways",
  "Custom Workflows",
  "Social Media Workflow Integrations",
  "Multilingual support",
];
const newFeatures = [
  "Custom Business Intelligence",
  "B2B AI Co-pilots",
  "Competitor Price Crawlers",
  "GeoLocation based Product Pricing",
];

export default function Comparison() {
  return (
    <section className={styles.comparison}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h2>
            Top features to solve your
            <span className={homeStyles["span-gradient"]}> B2B commerce </span>
            challenges{" "}
          </h2>
        </div>

        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead>
              <tr className={styles.theadRow}>
                <th className={styles.thFeature}>Features</th>
                <th className={styles.thPlatform}>
                  <div className={styles.platformBadge}>Our Platform</div>
                </th>
              </tr>
            </thead>

            <tbody>
              {features.map((feature, idx) => (
                <tr
                  key={idx}
                  className={`${styles.tbodyRow} ${
                    idx % 2 === 0 ? styles.even : ""
                  }`}
                >
                  <td className={styles.tdFeature}>
                    <span className={styles.featureText}>{feature}</span>

                    {newFeatures.includes(feature) && (
                      <span className={styles.newTag}>
                        New <span className={styles.star}>⭐</span>
                      </span>
                    )}
                  </td>
                  <td className={styles.tdCenter}>✓</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
